<template>
  <div class="users">
    <h2 class='title is-4'>Users</h2>
    <table class='table is-striped is-hoverable'>
      <thead>
        <tr>
          <th>Name</th>
          <th>Email</th>
          <th></th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(u, idx) in data" v-bind:key="u.id">
          <td>{{ u.user_name }}</td>
          <td>{{ u.email }}</td>
          <td><button class="button is-small is-fullwidth is-link" v-on:click="editUser(idx)">Edit</button></td>
          <td><button class='button is-small is-danger' v-on:click="deleteUser(idx)"><span class="icon is-small"><i class="fas fa-trash-alt"></i></span><span>Delete</span></button></td>
        </tr>
      </tbody>
    </table>
    <button class="button is-success" v-on:click="newUser">New User</button>

    <!-- Modal -->
    <div class="modal" v-bind:class="{ 'is-active' : active_modal }">
      <div class="modal-background"></div>
      <div class="modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title">{{ modal_title }}</p>
          <button class="delete" aria-label="close" v-on:click='closeModal()'></button>
        </header>
        <section class="modal-card-body">
          <!-- Content ... -->
          <div class="field">
            <label class="label">User name</label>
            <div class="control is-small">
              <input class="input" type="text" placeholder="e.g Blocks" v-model='edit.user_name' />
            </div>
          </div>
          <div class="field">
            <label class="label">Email</label>
            <div class="control is-small">
              <input class="input" type="text" placeholder="e.g Blocks" v-model='edit.email' />
            </div>
          </div>
          <div class="field">
            <label class="label">New password</label>
            <div class="control is-small">
              <input class="input" type="password" placeholder="Enter new password" v-model='new_password' />
            </div>
            <div class="control is-small">
              <input class="input" type="password" placeholder="...and again" v-model='new_password_2' />
            </div>
          </div>
          <!-- End of Content -->
        </section>
        <footer class="modal-card-foot">
          <button class="button is-success" v-on:click='saveUser()'>Save changes</button>
          <button class="button" v-on:click='closeModal()'>Cancel</button>
        </footer>
      </div>
    </div>
    <!-- End of Modal -->

  </div>
</template>


<script>
export default {
  name : 'users',
  data : function(){
    return {
      active_modal:   false,
      modal_title:    '',
      data:           [],
      edit:           {},
      editing:        false,
      new_password:   '',
      new_password_2: ''
    }
  },
  mounted(){
    this.getData();
  },
  methods : {
    getData : function(){
      this.callAPI('get', 'users')
        .then((res) => {
          this.data = res.data.users;
        })
        .catch((err) => { console.error(err); });
    },
    editUser : function(idx){
      this.modal_title = 'Edit User';
      this.edit = this.data[idx];
      this.editing = true;
      // console.log(this.edit);
      this.active_modal = !this.active_modal;
    },
    newUser : function(){
      this.modal_title = 'Create User';
      this.edit = {};
      this.new_password = '';
      this.new_password_2 = '';
      this.editing = false;
      this.active_modal = !this.active_modal;
    },
    saveUser : function(){
      console.log('Saving...', this.edit);
      let uri = '';
      let verb = '';
      let good_to_go = true;
      if(this.new_password.trim().length > 0){
        if(this.new_password.trim() === this.new_password_2.trim()){
          this.edit.password = this.new_password.trim();
        } else {
          good_to_go = false;
          alert('Passwords do not match');
        }
      }
      if(this.editing){ // True if Editing, false if Creating
        uri = 'users/'+ this.edit.id;
        verb = 'put';
        delete this.edit.id;
      } else {
        uri = 'users';
        verb = 'post';
      }
      if(good_to_go){
        this.callAPI(verb, uri, this.edit)
          .then((res) => {
            // console.log(res);
            this.getData();
          })
          .catch((err) => { console.error(err); });
        this.closeModal();
      }
    },
    closeModal : function(){
      this.active_modal = false;
    },
    deleteUser : function(idx){
      if(confirm("Are you sure you want to delete this user, this cannot be undone!")){
        this.callAPI('delete', `/users/${this.data[idx].id}`)
          .then((res) => { this.getData(); })
          .catch((err) => { console.error(err); });
      }
    },
  }
};
</script>